import Lang from './../bootstrap-lang';

$(document).ready(function($) {
    // Set the Options for "Bloodhound" suggestion engine
    var engine = new Bloodhound({
        remote: {
            url: route('shop.search').url() + '?q=%QUERY%',
            wildcard: '%QUERY%'
        },
        datumTokenizer: Bloodhound.tokenizers.whitespace('q'),
        queryTokenizer: Bloodhound.tokenizers.whitespace
    });

    // Post form when click on show more results
    $('body').on('click', '#view-all-results', function(e){
        e.preventDefault();
        $('.top-search form')[0].submit();
    });
    
    // Typeahead
    $("#search").typeahead({
        hint: true,
        highlight: true,
        minLength: 2
      }, {
        source: engine.ttAdapter(),
        limit: 10,
        name: 'searchList',
        display: 'title',
        templates: {
            empty: [
                '<div class="tt-suggestion">' +  Lang.get('frontend.search.no_results_message') + '</div>'
            ].join('\n'),
            suggestion:  function(data) {
                if(data.type == 'category'){
                    // return '<div class="tt-suggestion"><img class="icon icon-category embed-responsive-1by1" src="' + data.icon + '" />' + data.title + '<span class="text-muted ml-2">Categorie</span></div>';
                    return '<div class="tt-suggestion"><img class="float-left icon embed-responsive-1by1" src="' + data.icon + '" /><div class="float-left product-info"><p class="title">' + data.title + '</p><p class="category"><strong class="category-label">Categorie</strong></p></div><div class="clearfix"></div></div>';
                }else{
                    return '<div class="tt-suggestion"><img class="float-left icon embed-responsive-1by1" src="' + data.icon + '" /><span class="price float-right">' + data.price + '</span><div class="float-left product-info"><p class="title">' + data.title + '</p><p class="category">' + data.category + '</p></div><div class="clearfix"></div></div>';
                }
            },
            footer: '<span class="tt-footer"><a id="view-all-results" class="text-bold" href="#"><i class="fa fa-search mr-2" aria-hidden="true"></i> ' +  Lang.get('frontend.search.view_all_results') + '</a></span>'
          }
    }).on('typeahead:selected', function(event, selection) {
        window.location.href = selection.url;
    }).on('typeahead:render', function(event) {
        $('.form-search-bar').addClass('tt-open');
    }).on('typeahead:open', function(event) {
        $('.form-search-bar').addClass('tt-open');
    }).on('typeahead:close', function(event) {
        $('.form-search-bar').removeClass('tt-open');
    }).on('keypress', function(e) {
        if (e.which == 13) {
           var q = $('#search').val();
           if(q.length > 0){
            $('.top-search form')[0].submit();
           }
        }
});
});